import { render, staticRenderFns } from "./CompaniesListView.vue?vue&type=template&id=3b709450&"
import script from "./CompaniesListView.vue?vue&type=script&lang=ts&"
export * from "./CompaniesListView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports